import { createApp } from "vue";
import VueAgile from 'vue-agile';
import App from "./views/App/App.vue";
import router from "./router";
import { createPinia } from "pinia";

createApp(App).use(router).use(createPinia()).use(VueAgile).mount("#app");
